import { useMemo } from "react";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import type { WorkbookRunStatus } from "../../../../../api/types/workbookRuns.types";

interface Props {
  date: string;
  reportStatus: WorkbookRunStatus | undefined;
  errorMessage: string | undefined;
}

const WorkbookReportItemDate = ({ date, reportStatus, errorMessage }: Props) => {
  const text = useMemo(() => {
    if (reportStatus === "Queued") {
      return "Queued";
    }
    if (reportStatus === "InProgress") {
      return "Updating...";
    }
    if (reportStatus === "Error") {
      return errorMessage ?? "The report could not be updated.";
    }
    if (reportStatus === "Canceled") {
      return `${date} - Canceled`;
    }
    return date;
  }, [date, reportStatus, errorMessage]);

  const textColor = useMemo(() => {
    if (reportStatus === "Error") {
      return "error";
    }
    return "text.secondary";
  }, [reportStatus]);

  return (
    <TypographyTooltipEllipsis
      typographyProps={{ sx: { fontSize: "10px", lineHeight: "12px" }, color: textColor }}
      text={text}
    />
  );
};

export default WorkbookReportItemDate;
